import { createSlice } from "@reduxjs/toolkit";
import { RootState } from '../RootState';

const authSlice = createSlice({
    name: 'auth',
    //initialState: { user: null, token: null , refreshToken: null},
		 initialState: {
        user: sessionStorage.getItem("LoggedUserEmail") ?? null,
        token: sessionStorage.getItem("token") ?? null,
        refreshToken: sessionStorage.getItem("refreshToken") ?? null,
    },
    reducers: {
        setCredentials: (state, action) => {
            const { user, accessToken , refreshToken } = action.payload;
            state.user = user;
            state.token = accessToken;
            state.refreshToken = refreshToken;

            sessionStorage.setItem("LoggedUserEmail", user);
            sessionStorage.setItem("token", accessToken);
              if (refreshToken) {
                sessionStorage.setItem("refreshToken", refreshToken);
            }
        },
        logOut: (state) => {
            state.user = null;
            state.token = null;
            state.refreshToken = null;

            sessionStorage.removeItem("authToken");
            sessionStorage.removeItem("refreshToken");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("LoggedUserEmail");
            sessionStorage.removeItem("loginType");
            sessionStorage.removeItem("admin_authenticated");
            sessionStorage.removeItem("lastUserActivityAt");
        }
    },
})

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectCurrentToken = (state: RootState) => state.auth.token;
export const selectCurrentRefreshToken = (state: RootState) => state.auth.refreshToken;
